import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { Module } from "../hooks";

type Props = {
  open: boolean;
  onClose: () => void;
  module: Module;
};

export const HelpDialog: React.VFC<Props> = (props) => {
  const classes = useStyles();

  const {
    states: { dialogData },
    setters: { changeValue },
    actions: { onClickSave, onClickDelete },
  } = props.module;

  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth="md" fullWidth>
      {dialogData.docID === undefined && (
        <DialogTitle>ヘルプを登録します</DialogTitle>
      )}
      {dialogData.docID !== undefined && (
        <DialogTitle>ヘルプを更新します</DialogTitle>
      )}
      <DialogContent className={classes.dialogContent}>
        <TextField
          className={classes.dialogTextField}
          label="よくある質問"
          value={dialogData.question}
          onChange={(e) => changeValue(e, "question")}
          variant="outlined"
        />
        <TextField
          className={classes.dialogTextField}
          label="質問に対する回答"
          value={dialogData.answer}
          onChange={(e) => changeValue(e, "answer")}
          multiline
          rows={15}
          variant="outlined"
        />
      </DialogContent>
      <DialogActions>
        {dialogData.docID !== undefined && (
          <div className={classes.deleteButton}>
            <Button
              onClick={onClickDelete}
              color="secondary"
              variant="contained"
            >
              <DeleteIcon />
              &nbsp;削除する
            </Button>
          </div>
        )}
        <Button onClick={props.onClose} variant="contained">
          キャンセル
        </Button>
        <Button
          onClick={onClickSave}
          disabled={dialogData.question === "" || dialogData.answer === ""}
          color="secondary"
          variant="contained"
        >
          {dialogData.docID === undefined && <span>登録する</span>}
          {dialogData.docID !== undefined && <span>更新する</span>}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles({
  dialogContent: {
    paddingBottom: 20,
  },
  dialogTextField: {
    width: "100%",
    marginTop: 10,
    marginBottom: 10,
  },
  deleteButton: {
    flexGrow: 1,
  },
});
